'use strict';

/* Directives */

angular.module('substoreApp.directives')

    /**
     * Validator directive for an input; checks if the value is a valid email.
     */
    .directive('capEmail', ['emailValidationService', function(emailValidationService) {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.capEmail = function(modelValue, viewValue) {
                    if (ctrl.$isEmpty(modelValue)) {
                        return true; // consider empty models to be valid
                    }
                    return emailValidationService.isValid(viewValue);
                };
            }
        };
    }]);